jQuery(document).on('change','select#products-per-row-mobile', function() {
      localStorage.setItem("products-per-row-mobile", this.value);
      showcollectionimage();
});


  if(localStorage.getItem("products-per-row-mobile")!== null){
     
    jQuery('select#products-per-row-mobile').val(localStorage.getItem("products-per-row-mobile"));
    if(localStorage.getItem("products-per-row-mobile")==2){
      jQuery('.grid.grid--uniform').addClass('two-columns');
    } else if(localStorage.getItem("products-per-row-mobile")==1){
      jQuery('.grid.grid--uniform').removeClass('two-columns');
    }
      showcollectionimage();
 }else if(jQuery('.grid.grid--uniform').attr('checkalementtyope')!=""){
     jQuery('.grid.grid--uniform').addClass('two-columns');
    showcollectionimage();
 }

function showcollectionimage(){
 jQuery('.grid__image-ratio--square image-element').show();
  if (jQuery(window).width()<769){
    if(jQuery('.grid.grid--uniform').hasClass('two-columns')){
      jQuery('.mobile-element-1-colmn').css('display','none');
      jQuery('.mobile-element-2coumn').css('display','block');
    }else{
      jQuery('.mobile-element-2coumn').css('display','none');
      jQuery('.mobile-element-1-colmn').css('display','block');
    }
       
  }
  
}

window.addEventListener('resize', function(event) {
   showcollectionimage();
});